"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../../elements/Button"));
var _Control = _interopRequireDefault(require("./Control"));
var _ErrorMessage = _interopRequireDefault(require("./ErrorMessage"));
var _Field = _interopRequireDefault(require("./Field"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ToggleButtons = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    id,
    label,
    name,
    defaultValue,
    error,
    options,
    onChange,
    disabled
  } = _ref;
  const [selected, setSelected] = (0, _react.useState)();
  const handleChange = option => {
    setSelected(option);
    onChange(option);
  };
  (0, _react.useEffect)(() => {
    const firstOption = options && options.length > 0 ? options[0] : null;
    handleChange(defaultValue || (firstOption === null || firstOption === void 0 ? void 0 : firstOption.value));
  }, []);
  return /*#__PURE__*/_react.default.createElement(_Field.default, {
    hasAddons: true,
    label: label
  }, options && options.map((option, index) => /*#__PURE__*/_react.default.createElement(_Control.default, {
    key: `toggle_button_${option.value}_${index}`
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    ref: index === 0 ? ref : undefined,
    onClick: () => handleChange(option.value),
    isActive: selected === option.value,
    outlined: selected !== option.value,
    disabled: disabled,
    type: "button",
    color: "link"
  }, option.label))), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    id: id,
    name: name,
    value: selected
  }), error && /*#__PURE__*/_react.default.createElement(_ErrorMessage.default, null, error));
});
ToggleButtons.displayName = 'ToggleButtons';
ToggleButtons.propTypes = {
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.array]),
  disabled: _propTypes.default.bool,
  options: _propTypes.default.array,
  onChange: _propTypes.default.func,
  id: _propTypes.default.string,
  label: _propTypes.default.string,
  name: _propTypes.default.string,
  error: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string])
};
ToggleButtons.defaultProps = {
  options: []
};
var _default = exports.default = ToggleButtons;
//# sourceMappingURL=ToggleButtons.js.map